"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MONEY_SYMBOLS = void 0;
exports.MONEY_SYMBOLS = {
    EUR: '€',
    CZK: 'Kč',
    TRY: '₺',
    GBP: '£',
    CHF: 'CHF',
    CNY: '¥',
    RUB: '₽',
    INR: '₹',
    AED: 'د.إ',
    KWD: 'دينار',
    SAR: '﷼',
    BHD: 'دينار',
    QAR: '﷼',
    HKD: 'HK$',
    KRW: '₩',
    MOP: 'MOP$',
    TWD: 'NT$',
    THB: '฿',
    AUD: '$',
    MYR: 'RM',
    SGD: '$',
    JPY: '¥',
    USD: '$',
    CAD: '$',
    MXN: '$',
    BRL: 'R$',
    DKK: 'DKK'
};
